module.exports = __webpack_public_path__ + "static/media/footer-social-ins.e34eede5.png";